<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Comissões dos Parceiros</h3>
        </div>

        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
              v-b-tooltip.hover.bottom
              title="Filtros"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Parceiros</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Parceiro</th>
                    <th
                      scope="col"
                      class="border-0"
                      v-if="!IsPartnerNavigation"
                    >
                      CPF/CNPJ
                    </th>
                    <th
                      scope="col"
                      class="border-0"
                      v-if="!IsPartnerNavigation"
                    >
                      Tipo de parceiro
                    </th>
                    <th scope="col" class="border-0">Período</th>
                    <th scope="col" class="border-0" v-if="IsPartnerNavigation">
                      Status de transferência
                    </th>
                    <th scope="col" class="border-0" v-if="IsPartnerNavigation">
                      Nota de serviço enviada
                    </th>
                    <th scope="col" class="border-0">Valor comissionado</th>
                    <th
                      scope="col"
                      class="border-0"
                      v-if="$isAuthorize('Partner', 'GetDashboard')"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(partnerCommission, index) in partnerCommissions"
                    :key="index"
                  >
                    <td></td>
                    <td class="text-left">
                      {{ partnerCommission.Partner.Name }}
                    </td>
                    <td v-if="!IsPartnerNavigation">
                      {{ partnerCommission.Partner.Identity | identity }}
                    </td>
                    <td v-if="!IsPartnerNavigation">
                      {{ partnerCommission.Partner.PartnerType.Name }}
                    </td>
                    <td>{{ partnerCommission.ReleaseDate | monthYear }}</td>
                    <td v-if="IsPartnerNavigation">
                      <span
                        :class="[
                          GetTransferStatusClass(
                            partnerCommission.TransferStatus.Code,
                            partnerCommission.ReleaseDate
                          ),
                        ]"
                        >{{ partnerCommission.TransferStatus.Name }}</span
                      >
                    </td>
                    <td v-if="IsPartnerNavigation">
                      <i
                        :class="[
                          GetNoteExtractPartnerSentClass(
                            partnerCommission.IsNoteExtractPartnerSent,
                            partnerCommission.Partner.PartnerType.Code
                          ),
                        ]"
                      ></i>
                    </td>
                    <td>
                      <span class="badge badge-success">{{
                        partnerCommission.Amount | currency
                      }}</span>
                    </td>
                    <td v-if="$isAuthorize('Partner', 'GetDashboard')">
                      <button
                        class="btn btn-outline-secondary"
                        type="button"
                        v-on:click="
                          OpenPartnerCommission(
                            $event,
                            partnerCommission.Partner.Id,
                            partnerCommission.ReleaseDate
                          )
                        "
                      >
                        <i class="fas fa-dollar-sign mr-2"></i> Comissão
                      </button>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      partnerCommissions == undefined ||
                      partnerCommissions == null ||
                      partnerCommissions.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="Nome do parceiro"
            type="text"
            class="form-control"
            :disabled="filter.IdPartner > 0"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <d-select
            v-model="filter.IdPartner"
            :value="null"
            :disabled="
              IsPartnerNavigation ||
              (filter.Name != null &&
                filter.Name != undefined &&
                filter.Name.length > 0)
            "
          >
            <option :value="null" selected>Parceiro</option>
            <option
              v-for="partner in partners"
              v-bind:key="partner.Id"
              v-bind:value="partner.Id"
            >
              {{ partner.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <date-field
            v-model="filter.InitialDate"
            placeholder="Período"
            format="MMMM yyyy"
            minimumView="month"
          ></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodePartnerType" :value="null">
            <option :value="null" selected>Tipo de parceiro</option>
            <option
              v-for="type in partnerTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import DateField from "../common/date-field";

export default {
  name: "partner-commissions",
  components: {
    DateField,
  },
  data: function () {
    return {
      countFilter: 0,
      idPartner: 0,
      filter: {
        Name: null,
        IdPartner: this.idPartner > 0 ? this.idPartner : null,
        CodePartnerType: null,
        InitialDate:
          this.idPartner > 0 ? null : new Date().toJSON().substring(0, 10),
      },
      loadingList: false,
      loadingReport: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      partnerCommissions: [],
      partners: [],
      partnerTypes: [],
    };
  },
  computed: {
    IsPartnerNavigation() {
      return this.idPartner > 0;
    },
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListPartnerCommission();
    },
    "pagination.RowsPerPage": function () {
      this.ListPartnerCommission();
    },
  },
  mounted() {
    this.ListPartner();
    this.ListPartnerType();
    if (this.IsPartnerNavigation) {
      this.filter.IdPartner = this.idPartner;
      this.filter.InitialDate = null;
    }
    this.ListPartnerCommission();
  },
  beforeMount() {
    let params = this.$route.query;
    if (params != null) {
      if (params.idPartner) this.idPartner = parseInt(params.idPartner, 10);
    }
  },
  methods: {
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListPartnerCommission();
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportCheckingAccountPartner", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ListPartnerCommission: function () {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.IdPartner)) this.countFilter++;
      if (hasValue(this.filter.CodePartnerType)) this.countFilter++;
      if (hasValue(this.filter.InitialDate)) this.countFilter++;
      let data = this.GetParamsData();
      this.$store
        .dispatch("ListCheckingAccountPartner", { params: data })
        .then((response) => {
          this.partnerCommissions = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao listar as comissões",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ListPartner: function () {
      let data = { OrderByColumn: "Name" };
      this.$store
        .dispatch("ListPartner", { params: data })
        .then((response) => {
          this.partners = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de parceiros",
            error
          );
        });
    },
    ListPartnerType: function () {
      this.$store
        .dispatch("ListPartnerType")
        .then((response) => {
          this.partnerTypes = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter a lista com os tipos de parceiro",
            error
          );
        });
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    OpenPartnerCommission: function (e, id, releaseDate) {
      e.preventDefault();
      this.$router.push({
        name: "partner-commission",
        params: { idPartner: id },
        query: {
          initialDate: this.$options.filters.date(releaseDate, "YYYY-MM-DD"),
        },
      });
    },
    GetParamsData: function (deletePagination = false) {
      let data = {
        ...this.pagination,
        ...{
          InitialDate: this.filter.InitialDate,
          "Object.Partner.Name": this.filter.Name,
          "Object.Partner.Id": this.filter.IdPartner,
          "Object.Partner.PartnerType.Code": this.filter.CodePartnerType,
        },
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    ResetFilter: function () {
      this.filter = {
        Name: null,
        IdPartner: this.IsPartnerNavigation ? this.idPartner : null,
        CodePartnerType: null,
        InitialDate: null,
      };
      this.ListPartnerCommission();
    },
    GetNoteExtractPartnerSentClass: function (
      isNoteExtractPartnerSent,
      codePartnerType
    ) {
      if (codePartnerType == "1") return "fas fa-minus";
      return isNoteExtractPartnerSent
        ? "fas fa-check fa-green"
        : "fas fa-times fa-red";
    },
    GetTransferStatusClass: function (code) {
      let variation = "badge badge-warning";
      if (code == "3") {
        variation = "badge badge-success";
      } else if (code == "5") {
        variation = "badge badge-danger";
      }
      return variation;
    },
  },
};
</script>
<style scoped>
.fa-green {
  color: #0ac37f;
}
.fa-red {
  color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/partnerCommissions.vue